const activeInstances = [];

export const registerInstance = instance => {
  activeInstances.push(instance);
};

export const unregisterInstance = instance => {
  const index = activeInstances.indexOf(instance);

  if (index !== -1) {
    activeInstances.splice(index, 1);
  }
};

export const isTopmostInstance = instance =>
  activeInstances[activeInstances.length - 1] === instance;
